<div class="map-wrapper">
  <app-notifications class="visible-xs" ></app-notifications>
  <app-panel-message *ngIf="showNoListingsPopup && isDoneFetchingListings && (!visibleMarkers || visibleMarkers.length === 0) && !isClustering.value">
    <h4 translate="panel-message.no-results"></h4>
    <p>{{ 'panel-message.expand-search' | translate }}
      <ng-container  *ngIf="areFiltersEnabled">
        <ng-container *ngIf="screenSize <= SCREEN_SIZE.TABLET_LANDSCAPE_UP">
          <br/>
          <a (click)="openFilters($event)" translate="panel-message.change-filters-link"></a>
          <div class="text" translate="panel-message.or"></div>
        </ng-container>
      </ng-container>
      {{ 'panel-message.change-filters-map-text' | translate }}
    </p>
  </app-panel-message>
  <app-panel-message *ngIf="!isDoneFetchingListings || (isClustering.value && reloadAfterClustering)">
    <h4 translate="panel-message.getting-listings"></h4>
    <img [src]="('/assets/gifs/image-loader.gif' | staticp)" alt="{{'panel-message.loading-icon' | translate}}"/>
  </app-panel-message>
  <ng-content></ng-content>

  <ngui-map [options]="mapOptions"
            (idle)="onBoundsChanged($event)"
            (mapClick)="onMapClicked($event)"
            (zoom_changed)="onZoomChanged($event)"
            (mapReady$)="onMapReady($event)">
    <div id="heat-map" class="has-pos-abs"></div>

    <app-plain-marker *ngIf="showCurrentPhysicalLocationMarker"
                      [marker]="currentPhysicalLocationMarker"
                      [position]="[currentPhysicalLocationMarker.lat, currentPhysicalLocationMarker.lng]">
    </app-plain-marker>
    <app-plain-marker class="searchMarker" *ngIf="showSearchLocationMarker"
                      [marker]="searchLocationMarker"
                      [position]="[searchLocationMarker.lat, searchLocationMarker.lng]">
    </app-plain-marker>
  </ngui-map>

  <app-card-preview
      *ngIf="showListingPreviews && screenSize < SCREEN_SIZE.TABLET_LANDSCAPE_UP"
      [cards]="listingPreviews|async"
      (cardClicked)="onListingCardClicked($event)"
      (cardFocused)="onListingCardFocused($event)"
      [enableClosePreviewCards]="enableClosePreviewCards"
      [initialCardIndex]="initialListingIndex"
      [selectedListingIndex]= "selectedListingIndex"
      (swipedUpOnCard)="goToListing($event)"
      (hidePreview)="clearPreviews()">
    <ng-template let-card="card" let-isSelectedCard="isSelectedCard" let-isNextCard="isNextCard">
      <div class="listing swiper-slide">
        <app-listing-card
          (click)="onListingCardClicked($event)"
          [listing]="card"
          [confirmUnfavourite]="confirmUnfavourite"
          [isSelectedCard]="isSelectedCard"
          [isNextCard]="isNextCard"
          [isMapView]="true"
        ></app-listing-card>
      </div>
    </ng-template>
  </app-card-preview>
</div>
